import {
    SETTINGS_SEO_LISTING_DESCRIPTION,
    SETTINGS_SEO_LISTING_TITLE,
    SETTINGS_SEO_PRODUCT_DESCRIPTION,
    SETTINGS_SEO_PRODUCT_TITLE,
    SETTINGS_SEO_STATIC_DESCRIPTION,
    SETTINGS_SEO_STATIC_TITLE,
} from '../../constants';
import type { SettingSeoPaths } from '../hooks/useSettingsSeo';

const TITLE_KEYWORDS = '[TITLE]' as const;
const PRICE_MIN_KEYWORDS = '[PRICE_MIN]' as const;
const PRICE_MAX_KEYWORDS = '[PRICE_MAX]' as const;
const KEYWORDS = [TITLE_KEYWORDS, PRICE_MIN_KEYWORDS, PRICE_MAX_KEYWORDS];

type KeywordsKeys = (typeof KEYWORDS)[number];

const DEFAULT_TITLE_MAPPING = new Map<SettingSeoPaths, string>([
    [SETTINGS_SEO_PRODUCT_TITLE, 'Название товара'],
    [SETTINGS_SEO_PRODUCT_DESCRIPTION, 'Название товара'],
    [SETTINGS_SEO_LISTING_TITLE, 'Название коллекции/категории'],
    [SETTINGS_SEO_LISTING_DESCRIPTION, 'Название коллекции/категории'],
    [SETTINGS_SEO_STATIC_TITLE, 'Название страницы'],
    [SETTINGS_SEO_STATIC_DESCRIPTION, 'Название страницы'],
]);

const DEFAULT_PRICE_MIN_MAPPING = new Map<SettingSeoPaths, string>([
    [SETTINGS_SEO_PRODUCT_TITLE, 'Минимальная цена товара'],
    [SETTINGS_SEO_PRODUCT_DESCRIPTION, 'Минимальная цена товара'],
    [SETTINGS_SEO_LISTING_TITLE, 'Минимальная цена в коллекции/категории'],
    [SETTINGS_SEO_LISTING_DESCRIPTION, 'Минимальная цена в коллекции/категории'],
]);

const DEFAULT_PRICE_MAX_MAPPING = new Map<SettingSeoPaths, string>([
    [SETTINGS_SEO_PRODUCT_TITLE, 'Максимальная цена товара'],
    [SETTINGS_SEO_PRODUCT_DESCRIPTION, 'Максимальная цена товара'],
    [SETTINGS_SEO_LISTING_TITLE, 'Максимальная цена в коллекции/категории'],
    [SETTINGS_SEO_LISTING_DESCRIPTION, 'Максимальная цена в коллекции/категории'],
]);

const KEYWORDS_MAPPING = new Map<KeywordsKeys, Map<SettingSeoPaths, string>>([
    [TITLE_KEYWORDS, DEFAULT_TITLE_MAPPING],
    [PRICE_MIN_KEYWORDS, DEFAULT_PRICE_MIN_MAPPING],
    [PRICE_MAX_KEYWORDS, DEFAULT_PRICE_MAX_MAPPING],
]);

export const getSettingsSeoMetaExample = (template: string, id: SettingSeoPaths, title?: string) => {
    if (!template) {
        return template;
    }

    let result = template;

    KEYWORDS.forEach((keyword) => {
        const mapping = KEYWORDS_MAPPING.get(keyword);

        if (!mapping) {
            return;
        }

        const defaultValue = mapping.get(id);
        const replacementValue = title || defaultValue;

        if (!replacementValue) {
            return;
        }

        result = result.replaceAll(keyword, replacementValue);
    });

    return result;
};
